var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 1.66675H5C3.61667 1.66675 2.5 2.77508 2.5 4.14175V13.2334C2.5 14.6001 3.61667 15.7084 5 15.7084H5.63333C6.3 15.7084 6.93333 15.9667 7.4 16.4334L8.825 17.8417C9.475 18.4834 10.5333 18.4834 11.1833 17.8417L12.6083 16.4334C13.075 15.9667 13.7167 15.7084 14.375 15.7084H15C16.3833 15.7084 17.5 14.6001 17.5 13.2334V4.14175C17.5 2.77508 16.3833 1.66675 15 1.66675ZM13.9 8.75008L12.925 11.7167C12.8 12.2084 12.275 12.6084 11.7417 12.6084H10.2C9.93333 12.6084 9.55833 12.5167 9.39167 12.3501L8.16667 11.3917C8.14167 11.9251 7.9 12.1501 7.30833 12.1501H6.90833C6.29167 12.1501 6.04167 11.9084 6.04167 11.3251V7.35008C6.04167 6.76675 6.29167 6.52508 6.90833 6.52508H7.31667C7.93333 6.52508 8.18333 6.76675 8.18333 7.35008V7.65008L9.8 5.25008C9.96667 4.99175 10.3917 4.80841 10.75 4.95008C11.1417 5.08342 11.3917 5.51675 11.3083 5.90008L11.1083 7.20008C11.0833 7.30842 11.1083 7.42508 11.1833 7.50008C11.25 7.57508 11.35 7.62508 11.4583 7.62508H13.0833C13.4 7.62508 13.6667 7.75008 13.825 7.97508C13.975 8.19175 14 8.46675 13.9 8.75008Z",
    fill: "#0F55DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIcon);
export default __webpack_public_path__ + "static/media/like-icon.fd5019256b89140ee5304cfa4cf62239.svg";
export { ForwardRef as ReactComponent };